import CustomDrawer from 'components/commom/CustomDrawer';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Checkbox, CircularProgress, IconButton } from '@mui/material';
import LabelWithInput from 'components/commom/LabelWithPracticeInput';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import 'assets/styles/common.scss';
import ReusableTabs from 'components/commom/Tab';
import SelectInput from 'components/commom/SelectInput';
import { useDispatch, useSelector } from 'react-redux';
import CommonToast from 'components/commom/CommonToast';
import { useNavigate } from 'react-router-dom';
import { getDoctorDrop } from 'store/getDoctorListDropdown/getDoctorListDropdownAction';
import { ClearTokenRedirectLogin } from 'utils/general';
import { createEnterpriseCallAPI } from 'store/Enterprise/enterprise/createEnterprise/action';
import { updateEnterpriseCallAPI } from 'store/Enterprise/enterprise/updateEnterprise/action';

const CreateEnterprise = ({
  open,
  onClose,
  countryData,
  enterpriseTypeData,
  productInventoryData,
  editData,
}) => {
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const [formValue, setFormValue] = useState({
    enterpriseName: '',
    enterpriseType: 'External',
    adminName: '',
    email: '',
    address: '',
    // password: '',
    productInventory: '',
    tab: 1,
    skinBasic: false,
    skinAdvance: false,
    skinConcern: false,
    hairBasic: false,
    hairAdvance: false,
    previousScan: false,
    telemedicine: false,
    revenueCalculator: false,
    crm: false,
    productsRecommended: false,
    country: '',
    state: '',
    city: '',
    postalCode: '',
  });
  const [formSlug, setFormSlug] = useState({
    country: '',
    state: '',
    city: '',
  });
  const [phoneNumber, setPhoneNumber] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [isPassVisible, setIsPassVisible] = useState(false);
  const [stateData, setStateData] = useState({});
  const [cityData, setCityData] = useState({});

  const createLoader = useSelector(
    (state) => state?.createEnterpriseReducer?.loading
  );
  const updateLoader = useSelector(
    (state) => state?.updateEnterpriseReducer?.loading
  );

  const accessControlData = [
    { id: 1, name: 'Skin Analyser (Basic)', slug: 'skinBasic' },
    { id: 2, name: 'Skin Analyser (Advance)', slug: 'skinAdvance' },
    { id: 3, name: 'Skin Concern Identifier', slug: 'skinConcern' },
    { id: 4, name: 'Hair Analyser (Basic)', slug: 'hairBasic' },
    { id: 5, name: 'Hair Analyser (Advance)', slug: 'hairAdvance' },
    { id: 6, name: 'Previous Scans', slug: 'previousScan' },
    { id: 7, name: 'Telemedicine', slug: 'telemedicine' },
    { id: 8, name: 'Revenue Calculator', slug: 'revenueCalculator' },
    { id: 9, name: 'CRM', slug: 'crm' },
    { id: 10, name: 'Products recommended', slug: 'productsRecommended' },
  ];

  useEffect(() => {
    if (open) {
      initialState();
    }
  }, [open]);

  const initialState = () => {
    setFormValue({
      enterpriseName: editData?.id ? editData?.name : '',
      enterpriseType: editData?.id
        ? editData?.enterprise_type
        : enterpriseTypeData?.[0],
      adminName: editData?.id ? editData?.admin_details?.full_name : '',
      email: editData?.id ? editData?.email : '',
      address: editData?.id ? editData?.locations?.[0]?.address : '',
      // password: '',
      productInventory: editData?.id
        ? editData?.product_inventory
        : productInventoryData?.[0],
      tab: editData?.id
        ? productInventoryData?.findIndex(
            (item) => item?.id === editData?.product_inventory?.id
          ) + 1
        : 1,
      skinBasic: editData?.id
        ? editData?.access_control?.skin_analyser_basic
        : false,
      skinAdvance: editData?.id
        ? editData?.access_control?.skin_analyser_advance
        : false,
      skinConcern: editData?.id
        ? editData?.access_control?.skin_concern_identifier
        : false,
      hairBasic: editData?.id
        ? editData?.access_control?.hair_analyser_basic
        : false,
      hairAdvance: editData?.id
        ? editData?.access_control?.hair_analyser_advance
        : false,
      previousScan: editData?.id
        ? editData?.access_control?.previous_scans
        : false,
      telemedicine: editData?.id
        ? editData?.access_control?.telemedicine
        : false,
      revenueCalculator: editData?.id
        ? editData?.access_control?.revenue_calculator
        : false,
      crm: editData?.id ? editData?.access_control?.crm : false,
      productsRecommended: editData?.id
        ? editData?.access_control?.products_recommended
        : false,
      country:
        editData?.id && editData?.locations?.length > 0
          ? editData?.locations?.[0]?.country
          : '',
      state:
        editData?.id && editData?.locations?.length > 0
          ? editData?.locations?.[0]?.state
          : '',
      city:
        editData?.id && editData?.locations?.length > 0
          ? editData?.locations?.[0]?.city
          : '',
      postalCode:
        editData?.id && editData?.locations?.length > 0
          ? editData?.locations?.[0]?.postal_code
          : '',
    });
    setPhoneNumber(editData?.id ? editData?.contact_number : '');
    setCountryCode(editData?.id ? editData?.country_code : '');
    setIsPassVisible(false);
    if (editData?.id && editData?.locations?.length > 0) {
      const countryObj = countryData?.find(
        (item) => item?.name === editData?.locations[0]?.country
      );
      const countryId = countryObj?.id || '';
      if (countryId) {
        setFormSlug((prev) => ({
          ...prev,
          ['country']: countryId,
        }));
        getStateCityData(countryObj, 'country', true);
      }
    } else {
      setFormSlug({
        country: '',
        state: '',
        city: '',
      });
      setStateData({});
      setCityData({});
    }
  };

  const handleBack = () => {
    onClose();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'country' || name === 'state' || name === 'city') {
      if (name === 'country') {
        setFormValue((prev) => ({
          ...prev,
          [name]: value?.name,
          ['state']: '',
          ['city']: '',
        }));
        setFormSlug((prev) => ({
          ...prev,
          [name]: value?.id,
          ['state']: '',
          ['city']: '',
        }));
        getStateCityData(value, 'country');
      }
      if (name === 'state') {
        setFormValue((prev) => ({
          ...prev,
          [name]: value?.name,
          ['city']: '',
        }));
        setFormSlug((prev) => ({
          ...prev,
          [name]: value?.id,
          ['city']: '',
        }));
        getStateCityData(value, 'state');
      }
      if (name === 'city') {
        setFormValue((prev) => ({
          ...prev,
          [name]: value?.name,
        }));
        setFormSlug((prev) => ({
          ...prev,
          [name]: value?.id,
        }));
        getStateCityData(value, 'state');
      }
    } else {
      setFormValue((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const getStateCity = (data, type) => {
    if (type === 'state') {
      setStateData(data);
      const stateObj = data?.find(
        (item) => item?.name === editData.locations[0].state
      );
      const stateId = stateObj?.id || '';
      if (stateId) {
        setFormSlug((prev) => ({
          ...prev,
          ['state']: stateId,
        }));
        getStateCityData(stateObj, 'state', true);
      }
    }
    if (type === 'city') {
      setCityData(data);
      const cityObj = cityData?.find(
        (item) => item?.name === editData.locations[0].city
      );
      const cityId = cityObj?.id || '';
      if (cityId) {
        setFormSlug((prev) => ({
          ...prev,
          ['city']: cityId,
        }));
      }
    }
  };

  const getStateCityData = (data, type, fromEdit = false) => {
    dispatch(
      getDoctorDrop(
        {
          run: true,
          handleFunction: (res) => {
            if (editData?.id) {
              if (type === 'country') {
                getStateCity(res?.data, 'state');
              }
              if (type === 'state') {
                getStateCity(res?.data, 'city');
              }
            } else {
              if (type === 'country') {
                setStateData(res?.data);
              }
              if (type === 'state') {
                setCityData(res?.data);
              }
            }
          },
          authorize: true,
          handleAuthorizeFunction: (res) => {
            ClearTokenRedirectLogin(navigate);
          },
          error: true,
          handleErrorFunction: (res) => {
            showToast(res?.message, 'error');
          },
        },
        `${
          type === 'country'
            ? data?.id
            : fromEdit
              ? countryData?.find(
                  (item) => item?.name === editData.locations[0].country
                )?.id
              : formSlug?.country
        }`,
        `${type === 'state' ? data?.id : ''}`
      )
    );
  };

  const handleData = (data, type) => {
    setFormValue((prev) => ({
      ...prev,
      [type]: data,
      productInventory:
        data?.slug === 'internal'
          ? productInventoryData?.find((item) => item?.slug === 'both')
          : productInventoryData?.[0],
      tab:
        data?.slug === 'internal'
          ? productInventoryData?.findIndex((item) => item?.slug === 'both') + 1
          : 1,
      skinBasic: data?.slug === 'internal' ? true : false,
      skinAdvance: data?.slug === 'internal' ? true : false,
      skinConcern: data?.slug === 'internal' ? true : false,
      hairBasic: data?.slug === 'internal' ? true : false,
      hairAdvance: data?.slug === 'internal' ? true : false,
      previousScan: data?.slug === 'internal' ? true : false,
      telemedicine: data?.slug === 'internal' ? true : false,
      revenueCalculator: data?.slug === 'internal' ? true : false,
      crm: data?.slug === 'internal' ? true : false,
      productsRecommended: data?.slug === 'internal' ? true : false,
    }));
  };

  const handlePhoneChange = (value, country) => {
    const countryCode = `+${country?.dialCode}`;
    const contactNumber = value.replace(country?.dialCode, '').trim();

    setPhoneNumber(contactNumber);
    setCountryCode(countryCode);
  };

  const handleTabChange = (val) => {
    const tab = productInventoryData[val - 1];
    setFormValue((prev) => ({
      ...prev,
      ['tab']: val,
      ['productInventory']: tab,
    }));
  };

  const handleChange = (e) => {
    const { name, checked } = e.target;
    setFormValue((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleSave = () => {
    if (
      !formValue?.enterpriseName ||
      !formValue?.email ||
      !phoneNumber ||
      !formValue?.address ||
      !formValue?.city ||
      !formValue?.state ||
      !formValue?.country ||
      !formValue?.adminName ||
      (formSlug?.country !== 2 && !formValue?.postalCode)
    ) {
      showToast('Please fill all the required fields', 'error');
      return;
    }
    const body = {
      id: editData?.id,
      detail: {
        [editData?.id ? 'name' : 'enterprise_name']: formValue?.enterpriseName,
        email: formValue?.email,
        contact_number: phoneNumber,
        country_code: countryCode,
        ...(!editData?.id && { location_name: formValue?.enterpriseName }),
        ...(!editData?.id && { location_address: formValue?.address }),
        ...(!editData?.id && { city: formValue?.city }),
        ...(!editData?.id && { state: formValue?.state }),
        ...(!editData?.id && { country: formValue?.country }),
        ...(!editData?.id &&
          formSlug?.country !== 2 && { postal_code: formValue?.postalCode }),
        ...(editData?.id && {
          location: {
            location_address_id: editData?.locations?.[0]?.id,
            address: formValue?.address,
            city: formValue?.city,
            state: formValue?.state,
            country: formValue?.country,
            ...(formSlug?.country !== 2 && {
              postal_code: formValue?.postalCode,
            }),
            name: formValue?.enterpriseName,
          },
        }),
        enterprise_type_id: formValue?.enterpriseType?.id,
        product_inventory_id: formValue?.productInventory?.id,
        is_internal:
          formValue?.enterpriseType?.slug === 'internal' ? true : false,
        [editData?.id ? 'admin_name' : 'admin_full_name']: formValue?.adminName,
        // ...(!editData?.id && { password: formValue?.password }),
        skin_analyser_basic: formValue?.skinBasic,
        skin_analyser_advance: formValue?.skinAdvance,
        skin_concern_identifier: formValue?.skinConcern,
        hair_analyser_basic: formValue?.hairBasic,
        hair_analyser_advance: formValue?.hairAdvance,
        previous_scans: formValue?.previousScan,
        telemedicine: formValue?.telemedicine,
        revenue_calculator: formValue?.revenueCalculator,
        crm: formValue?.crm,
        products_recommended: formValue?.productsRecommended,
      },
    };

    if (editData?.id) {
      dispatch(
        updateEnterpriseCallAPI(body, {
          run: true,
          handleFunction: (res) => {
            showToast(res?.message, 'success');
            handleBack();
          },
          authorize: true,
          handleAuthorizeFunction: (res) => {
            ClearTokenRedirectLogin(navigate);
          },
          error: true,
          handleErrorFunction: (res) => {
            showToast(res?.message, 'error');
          },
        })
      );
    } else {
      dispatch(
        createEnterpriseCallAPI(body?.detail, {
          run: true,
          handleFunction: (res) => {
            showToast(res?.message, 'success');
            handleBack();
          },
          authorize: true,
          handleAuthorizeFunction: (res) => {
            ClearTokenRedirectLogin(navigate);
          },
          error: true,
          handleErrorFunction: (res) => {
            const dataMessages = res?.data && Object.values(res.data).flat();
            const errorMessage = dataMessages?.length
              ? dataMessages[0]
              : res?.message;
            showToast(errorMessage, 'error');
          },
        })
      );
    }
  };

  return (
    <CustomDrawer
      open={open}
      onClose={() => {
        handleBack();
      }}
      width={{ xs: '100vw', md: '70vw', xl: '40vw' }}
    >
      <div className="relative h-full min-h-[400px] flex flex-col">
        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto p-[25px] pb-[15%]">
          <div className="mt-[43px]">
            <div className="flex items-center justify-between gap-[20px]">
              <p className="p-0 m-0 text-[24px] text-[#292D32] family_outfit_semiBold_600 lh-176">
                Invite Enterprise/Admin
              </p>
              <IconButton onClick={handleBack}>
                <CloseIcon />
              </IconButton>
            </div>
            {/* <div className="my-[24px] flex justify-end">
              <ReusableButton
                fullWidth={false}
                variant="outlined"
                color="#3C3C3C"
                fontSize="16px"
                fontWeight="500"
                padding="14px 24px"
                borderRadius="0px"
                height="44px"
                bgColor="transparent"
                brColor="#3C3C3C"
                fontFamily="outfit_medium"
                onClick={() => {}}
                endIcon={<RefreshIcon fontSize="small" />}
              >
                Resend Invite
              </ReusableButton>
            </div> */}
            <div className="mt-[24px]">
              <LabelWithInput
                label={
                  <>
                    Enterprise Name <span style={{ color: 'red' }}>*</span>
                  </>
                }
                placeholder="Enterprise Name"
                name="enterpriseName"
                type="text"
                value={formValue?.enterpriseName}
                onChange={(e) => handleInputChange(e)}
                // errorText={
                //   isError &&
                //   isError?.question_text?.error &&
                //   isError?.question_text?.errorMessage
                // }
              />
            </div>
            <div className="mt-[16px]">
              <div className="text-[14px] lh-201 family_outfit_medium_500 fc-292D32">
                Enterprise Type
              </div>
              <div className="mt-[4px] grid grid-cols-2 gap-[10px]">
                {open &&
                  enterpriseTypeData?.map((data, index) => (
                    <div
                      key={index}
                      className={`text-[14px] family_outfit_regular_400 lh-16 h-[45px] cursor-pointer flex items-center justify-center border-1 border-[#998A7B] ${formValue?.enterpriseType?.slug === data?.slug ? 'bg-[#874529] text-white' : 'text-[#874529]'}`}
                      onClick={() => {
                        handleData(data, 'enterpriseType');
                      }}
                    >
                      <div>{data?.name}</div>
                    </div>
                  ))}
              </div>
            </div>
            <div className="mt-[16px]">
              <LabelWithInput
                label={
                  <>
                    Admin Name <span style={{ color: 'red' }}>*</span>
                  </>
                }
                placeholder="Admin Name"
                name="adminName"
                type="text"
                value={formValue?.adminName}
                onChange={(e) => handleInputChange(e)}
              />
            </div>
            <div className="mt-[16px]">
              <div className="text-[14px] lh-201 family_outfit_medium_500 fc-292D32 mb-[4px]">
                Mobile number <span style={{ color: 'red' }}>*</span>
              </div>
              <PhoneInput
                id="phone-input"
                country={'in'}
                inputProps={{
                  name: 'phoneNumber',
                  required: true,
                }}
                name={'phoneNumber'}
                value={`${countryCode}${phoneNumber}`}
                onChange={(value, country) => handlePhoneChange(value, country)}
                placeholder="Enter phone number"
                inputClass="custom-input-register"
                containerClass="custom-container-register"
              />
            </div>
            <div className="mt-[16px]">
              <LabelWithInput
                label={
                  <>
                    Email ID <span style={{ color: 'red' }}>*</span>
                  </>
                }
                placeholder="Email ID"
                name="email"
                type="text"
                value={formValue?.email}
                onChange={(e) => handleInputChange(e)}
              />
            </div>
            <div className="mt-[16px]">
              <LabelWithInput
                label={
                  <>
                    Address <span style={{ color: 'red' }}>*</span>
                  </>
                }
                placeholder="Address"
                name="address"
                type="text"
                value={formValue?.address}
                onChange={(e) => handleInputChange(e)}
              />
            </div>
            <div className="mt-[16px]">
              <SelectInput
                label={
                  <>
                    Country <span style={{ color: 'red' }}>*</span>
                  </>
                }
                placeholder={'Country'}
                colorIcon={'#292D32'}
                name={'country'}
                value={formValue?.country}
                data={countryData || []}
                onChange={handleInputChange}
              />
            </div>
            <div className="mt-[16px]">
              <SelectInput
                label={
                  <>
                    State <span style={{ color: 'red' }}>*</span>
                  </>
                }
                placeholder={'State'}
                colorIcon={'#292D32'}
                name={'state'}
                value={formValue?.state}
                data={stateData || []}
                onChange={handleInputChange}
                disabled={!formValue?.country?.length}
              />
            </div>
            <div className="mt-[16px]">
              <SelectInput
                label={
                  <>
                    City <span style={{ color: 'red' }}>*</span>
                  </>
                }
                placeholder={'City'}
                colorIcon={'#292D32'}
                name={'city'}
                value={formValue?.city}
                data={cityData || []}
                onChange={handleInputChange}
                disabled={!formValue?.state?.length}
              />
            </div>
            {formSlug?.country !== 2 && (
              <div className="mt-[16px]">
                <LabelWithInput
                  label={
                    <>
                      Postal Code <span style={{ color: 'red' }}>*</span>
                    </>
                  }
                  placeholder="Postal Code"
                  name="postalCode"
                  type="text"
                  value={formValue?.postalCode}
                  onChange={(e) => handleInputChange(e)}
                />
              </div>
            )}
            {/* {!editData?.id && (
              <div className="mt-[16px]">
                <LabelWithInput
                  label={
                    <>
                      Password <span style={{ color: 'red' }}>*</span>
                    </>
                  }
                  placeholder="Password"
                  name="password"
                  value={formValue?.password}
                  type={isPassVisible ? 'text' : 'password'}
                  onChange={handleInputChange}
                  InputProps={{
                    endAdornment: (
                      <>
                        {isPassVisible ? (
                          <VisibilityOutlinedIcon
                            sx={{ cursor: 'pointer', color: '#A4AAB2' }}
                            onClick={() => setIsPassVisible(!isPassVisible)}
                          />
                        ) : (
                          <VisibilityOffOutlinedIcon
                            sx={{ cursor: 'pointer', color: '#A4AAB2' }}
                            onClick={() => setIsPassVisible(!isPassVisible)}
                          />
                        )}
                      </>
                    ),
                  }}
                  // errorText={
                  //   isError &&
                  //   isError.password.error &&
                  //   isError.password.errorMessage
                  // }
                />
              </div>
            )} */}
            <div className="mt-[16px]">
              <div className="text-[14px] lh-201 family_outfit_medium_500 fc-292D32 mb-[4px]">
                Product Inventory
              </div>
              <ReusableTabs
                tabs={productInventoryData}
                defaultTab={formValue?.tab}
                currentTab={(val) => handleTabChange(val)}
                background={'#864629'}
                color={'#FFFFFF'}
                tabColor={'#A2A2A2'}
                completeColor={'#FFFFFF'}
                boxShadow={'0px 3px 16px 0px #00000014'}
              />
            </div>
            <div className="mt-[16px]">
              <div className="text-[18px] lh-201 family_outfit_semiBold_600 fc-292D32 mb-[20px]">
                Access Control
              </div>
              <div className="grid grid-cols-1 gap-[10px]">
                {accessControlData?.map((item, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between"
                  >
                    <div className="text-[14px] lh-201 family_outfit_regular_400 fc-292D32">
                      {item?.name}
                    </div>
                    <Checkbox
                      name={item?.slug}
                      onChange={handleChange}
                      sx={{
                        color: '#864629',
                        '&.Mui-checked': {
                          color: '#864629',
                        },
                        '&:hover': {
                          backgroundColor: 'rgba(134, 70, 41, 0.08)',
                        },
                      }}
                      checked={
                        item?.id === 1
                          ? formValue?.skinBasic
                          : item?.id === 2
                            ? formValue?.skinAdvance
                            : item?.id === 3
                              ? formValue?.skinConcern
                              : item?.id === 4
                                ? formValue?.hairBasic
                                : item?.id === 5
                                  ? formValue?.hairAdvance
                                  : item?.id === 6
                                    ? formValue?.previousScan
                                    : item?.id === 7
                                      ? formValue?.telemedicine
                                      : item?.id === 8
                                        ? formValue?.revenueCalculator
                                        : item?.id === 9
                                          ? formValue?.crm
                                          : item?.id === 10
                                            ? formValue?.productsRecommended
                                            : false
                      }
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* Absolutely Positioned Bottom Button */}
        <div
          className="mt-[30px] absolute left-0 bottom-0 w-full bg-[#375241] p-[30px] cursor-pointer"
          onClick={() => {
            !createLoader && !updateLoader && handleSave();
          }}
        >
          <div className="text-[24px] text-white family_outfit_semiBold_600 lh-176 text-center flex items-center justify-center gap-[10px]">
            {'Save'}
            {createLoader || updateLoader ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <span
                style={{ width: 24, height: 24, display: 'inline-block' }}
              />
            )}
          </div>
        </div>
      </div>
    </CustomDrawer>
  );
};

export default CreateEnterprise;
